export default __webpack_public_path__ + "vision7f45ce.png";